import _defineProperty from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */

/**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */
export var mapIterator = function mapIterator(iterator, f) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, Symbol.iterator, function () {
    return this;
  }), _defineProperty(_ref, "next", function next() {
    var r = iterator.next();
    return {
      value: r.done ? undefined : f(r.value),
      done: r.done
    };
  }), _ref;
};
/**
 * @template T
 * @param {function():IteratorResult<T>} next
 * @return {IterableIterator<T>}
 */

export var createIterator = function createIterator(next) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, Symbol.iterator, function () {
    return this;
  }), _defineProperty(_ref2, "next", next), _ref2;
};
/**
 * @template T
 * @param {Iterator<T>} iterator
 * @param {function(T):boolean} filter
 */

export var iteratorFilter = function iteratorFilter(iterator, filter) {
  return createIterator(function () {
    var res;

    do {
      res = iterator.next();
    } while (!res.done && !filter(res.value));

    return res;
  });
};
/**
 * @template T,M
 * @param {Iterator<T>} iterator
 * @param {function(T):M} fmap
 */

export var iteratorMap = function iteratorMap(iterator, fmap) {
  return createIterator(function () {
    var _iterator$next = iterator.next(),
        done = _iterator$next.done,
        value = _iterator$next.value;

    return {
      done: done,
      value: done ? undefined : fmap(value)
    };
  });
};